import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch page Description list data
export const getNotificationUpdateList = createAsyncThunk(
  "notificationUpdateList/getNotificationUpdateList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/notification/update_notification_view`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const notificationUpdateSlice = createSlice({
  name: "notificationUpdateList",
  initialState: {
    loading: false,
    notificationUpdateData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNotificationUpdateList.pending, (state) => {
        state.loading = true;
        state.notificationUpdateData = null; // Reset to prevent showing old data
        state.error = null;
      })
      .addCase(getNotificationUpdateList.fulfilled, (state, action) => {
        state.loading = false;
        state.notificationUpdateData = action.payload;
      })
      .addCase(getNotificationUpdateList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default notificationUpdateSlice.reducer;
